// ignore in develpoment
// see "/build/update-build-id.js"
import axios from "axios";

import bus from "../components/common/bus";

const { build } = require('../../config');

(() => {
  if (process.env.NODE_ENV === 'development') return;

  const baseURL = `${build.assetsPublicPath}/${build.assetsSubDirectory}`.replace(/\//g, '/').replace(/\/\//g, '/');

  const bidKey = 'app.bid';

  function updateBId(newBId) {
    sessionStorage.setItem(bidKey, newBId)
  }

  function poolBId() {
    setTimeout(() => {
      const url = `bid.js?ts=${Date.now()}&qt=-quietly`;
      axios.get(url, {
        baseURL
      }).then((res) => {
        const oldBId = sessionStorage.getItem(bidKey);
        const newBId = res.data['bid'];
        if (oldBId) {
          if (oldBId !== newBId) {
            bus.$emit('update:bid', newBId, oldBId, () => updateBId(newBId));
          }
        } else {
          updateBId(newBId);
        }
      })
      .catch(() => 0)
      .then(() => {
        poolBId();
      });
    }, 5000 + parseInt(5000 * Math.random()));
  }
  poolBId();
})();


// WEBPACK FOOTER //
// ./src/utils/sync-bid.js